import React from 'react';
import { goToStep, setPreviousQuestion } from '../../redux/reducers/quiz-reducer';

class WizardItemRadioButtons extends React.Component {

	constructor(props) {

		super(props);
		this.state = {
			selected: null
		};

		this.selectOption = this.selectOption.bind(this);
	}


	selectOption(e) {
		let id = e.target.value;
		this.setState({ selected: id });
		this.props.submitAnswer(id);
	}

	componentDidUpdate() {
		if ((this.state.selected !== null) && ((this.props.previousQuestion > this.props.currentStep) && (this.props.data.Buttons.HideButtonsBelowQuestion && (this.props.goToRev && (this.props.currentStep === this.props.data.CurrentItem - 1))))) {
			this.setState({ selected: null })
		}
		this.props.setRev(false);

	}

	render() {
		return (
			<div className="wizard-item wizard-item__radio-button">
				<radiogroup>

					{this.props.data.Options.map((rb, idx) => {
						return (
							<div className="radio-button" key={idx} >
								<input
									type="radio"
									id={"rb-" + rb.Id}
									value={rb.Id ? rb.Id : ''}
									checked={(rb.Id === this.state.selected)}
									name={this.props.data.Id}
									onClick={this.selectOption}
									/>
								<label htmlFor={"rb-" + rb.Id} >{rb.Header}</label>
							</div>
						)
					})}
				</radiogroup>
			</div>
		)
	}
}

export default WizardItemRadioButtons;